const resources = {
    sponsored: 'Sponsored',
    alt: 'Banner image with sponsored content',
    featuredProduct: 'Featured Products'
};

export default function getResource(label) {
    return resources[label];
}
